import type { DocumentsLinkProps } from './DocumentsLink.types';
import type * as react from 'react';

import * as uiLib from '@compliance.ai/web-components';

import { useDocumentsLinkData, useDocumentsLinkHandlers, useDocumentsLinkMutations } from './hooks';

import './_documents-link.scss';

export const DocumentsLink: react.FC<DocumentsLinkProps> = ({ actionButtonType }) => {
  const { localState, localActions, formattedData } = useDocumentsLinkData();

  const mutations = useDocumentsLinkMutations({ localActions, formattedData });

  const handlers = useDocumentsLinkHandlers({ localState, localActions });

  return (
    <>
      <uiLib.Tooltip title={'Generate a link for your search'} type={uiLib.TOOLTIP_TYPES.SECONDARY}>
        <uiLib.ActionButton onClick={mutations.getShortURL.mutate} type={actionButtonType}>
          {mutations.getShortURL.isPending && (
            <uiLib.Loader size={uiLib.LOADER_SIZES.SMALL} withoutBackground={false} />
          )}
          <uiLib.IconURL className="documents-link__icon" />
        </uiLib.ActionButton>
      </uiLib.Tooltip>
      {!!localState.url && formattedData.isSafari && (
        <uiLib.Modal
          isOpen={localState.isModalOpen}
          onClose={handlers.handleModalClose}
          title={'Generated link'}
          onBackdropClick={handlers.handleModalClose}
          classNames={{
            container: 'documents-link__modal',
            content: 'documents-link__modal-content'
          }}
        >
          <>
            <div>{localState.url}</div>
            <uiLib.Button type={uiLib.BUTTON_TYPES.LINK} onClick={handlers.handleUrlCopy}>
              Copy to clipboard
            </uiLib.Button>
          </>
        </uiLib.Modal>
      )}
    </>
  );
};
